import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { round } from 'lodash';
import HeightSelect from './height-select';
import './index.css';

const unitValues = {
  cm: {
    min: 30,
    max: 300,
    maxPercent: -90,
    tickDistance: .3333457249,
    conversion: 1,
    sliderWidth: 3000,
    tickDistances: [{
      distance: 10,
      className: 'large-tick',
      displayValue: true
    },
    {
      distance: 5,
      className: 'medium-tick',
      displayValue: false
    }]
  },
  in: {
    min: 36,
    max: 96,
    maxPercent: -60,
    tickDistance: 1,
    conversion: .3937007874,
    sliderWidth: 1000,
    tickDistances: [{
      distance: 12,
      className: 'large-tick',
      displayValue: false
    }]
  }
};

class UserProfileHeight extends Component {
  static propTypes = {
    initialValue: PropTypes.number.isRequired,
    initialUnit: PropTypes.string.isRequired,
    setHeight: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);

    this.state = {
      metricHeight: props.initialValue,
      heightUnit: props.initialUnit,
    };

    this.setHeight = this.setHeight.bind(this);
    this.setHeightUnit = this.setHeightUnit.bind(this);
  }

  setHeightOne = (event, value, payload) => {
    let total;
    const displayHeight = this.getDisplayHeight();
    displayHeight.valueOne = payload;
    if (this.state.heightUnit === 'metric') {
      total = displayHeight.valueOne * 100 + displayHeight.valueTwo;
    } else {
      total = displayHeight.valueOne * 12 + displayHeight.valueTwo;
    }
    this.setHeight(total);
  }

  setHeightTwo = (event, value, payload) => {
    let total;
    const displayHeight = this.getDisplayHeight();
    if (this.state.heightUnit === 'metric') {
      total = displayHeight.valueOne * 100 + payload;
    } else {
      total = displayHeight.valueOne * 12 + payload;
    }
    this.setHeight(total);
  }

  setHeight = (payload) => {
    const unitSystem = this.state.heightUnit === 'metric' ? 'metric' : 'standard';
    let metricHeight;
    if (this.state.heightUnit === 'metric') {
      metricHeight = payload;
    } else {
      metricHeight = round(payload / (unitValues.in.conversion / unitValues.cm.conversion), 1);
    }
    this.setState({ metricHeight });
    this.props.setHeight(metricHeight, unitSystem);
  }

  setHeightUnit(event, value, payload) {
    if (this.state.heightUnit !== payload) {
      this.setState({ heightUnit: payload });
      this.props.setHeight(this.state.metricHeight, payload);
    }
  }

  getDisplayHeight() {
    let displayHeight;

    if (this.state.heightUnit === 'metric') {
      displayHeight = {
        valueOne: Math.floor(this.state.metricHeight / 100),
        valueTwo: Math.floor(this.state.metricHeight % 100)
      };
    } else {
      const usHeight = round(this.state.metricHeight / (unitValues.cm.conversion / unitValues.in.conversion), 1);
      const feet = Math.floor(usHeight / 12);
      const inches = Math.floor(usHeight % 12);

      displayHeight = {
        valueOne: feet,
        valueTwo: inches
      };
    }

    return displayHeight;
  }

  render() {
    return (
      <HeightSelect
        setHeightUnit={ this.setHeightUnit }
        setHeightOne={ this.setHeightOne }
        setHeightTwo={ this.setHeightTwo }
        displayHeight={ this.getDisplayHeight() }
        heightUnit={ this.state.heightUnit }
      />
    );
  }
}

export default UserProfileHeight;
